module.exports = __webpack_public_path__ + "img/printer2.1578a2c3.png";